<template>
    <div class="scheduled-calendar flex column">
        <div class="tabs flex align-center justify-center pl10 pr10">
            <calendar class="pa0"
            v-model="scheduledDateFilter"
            onlyMonths
            @OnClickMonth="AddMonth($event)"
            @OnClickYear="SelectYear($event)"
            >
            </calendar>

        </div>

        <div class="calendar-week-header">
            <div
                v-for="day in weekDays"
                :key="day"
                class="week-day cgray1">
                {{ day }}
            </div>
        </div>

        <div class="calendar-grid">

            <div
                v-for="cell in daysGrid"
                :key="cell.date"
                class="calendar-day"
                :class="{
                    'other-month': cell.month != currentMonth,
                    'today': cell.date == today,
                }"
                :style="{
                    cursor: TicketsForDate(cell.date).length > 0 ? 'pointer' : null
                }"
                @click="TicketsForDate(cell.date).length ? $emit('SelectDayScheduleCalendar', cell.date) : null"
            >
                <!-- NÚMERO DEL DÍA -->
                <div class="day-header">
                    <span
                        class="day-number"
                        :class="{'today-number': cell.date == today }"
                    >
                        {{ cell.day }}
                    </span>

                    <span
                        v-if="TicketsForDate(cell.date).length && !mobile"
                        class="day-counter"
                    >
                        {{ TicketsForDate(cell.date).length }}
                    </span>
                </div>

                <div class="day-tickets">
                    <template v-if="!mobile">
                    <div
                        v-for="ticket in VisibleTicketsForDate(cell.date)"
                        :key="ticket.id"
                        class="scheduled-ticket "
                    >
                        <div class="ticket-time">
                            {{ TicketTime(ticket) }}
                        </div>
                        <div class="ticket-customer">
                            {{ TicketCustomer(ticket) }}
                        </div>
                    </div>

                    <span
                        v-if="HiddenTicketsCount(cell.date) > 0"
                        class="more-tickets "
                    >
                        + {{ HiddenTicketsCount(cell.date) }} más
                    </span>                    
                </template>
                <span
                        v-else-if="TicketsForDate(cell.date).length && mobile"
                        class="day-counter"
                    >
                        {{ TicketsForDate(cell.date).length }}
                    </span>
                </div>

            </div>

        </div>

    </div>
</template>


<script>
var moment = require('moment');
export default {
props: {
    tickets: {
        type: Array,
        default: function() {
            return [];
        }
    },
},

data() {
    var date = moment();
    return {
        currentMonth: date.month(),
        currentYear: date.year(),
        today: date.format('DD/MM/YYYY'),
        weekDays: [
            'LUN',
            'MAR',
            'MIÉ',
            'JUE',
            'VIE',
            'SÁB',
            'DOM'
        ],
        scheduledDateFilter : null
    }
},

computed: {
    ticketsByDate(){
        var grouped = {};

        for(var i = 0; i < this.tickets.length; i++)
        {
            var ticket = this.tickets[i];

            if(ticket.status != 'SCHEDULED')
                continue;

            if(
                !ticket.custom_data ||
                !ticket.custom_data.scheduled_at
            )
                continue;

            var date = moment.unix(ticket.custom_data.scheduled_at);

            if(!date.isValid())
                continue;

            var dateKey = date.format('DD/MM/YYYY');

            if(!grouped[dateKey])
                grouped[dateKey] = [];

            grouped[dateKey].push(ticket);
        }

        Object.keys(grouped).forEach(date => {

            grouped[date].sort((a, b) => {
                return a.custom_data.scheduled_at - b.custom_data.scheduled_at;
            });

        });

        return grouped;
    },
    daysGrid(){
        var firstDay = moment().month(this.currentMonth).year(this.currentYear).startOf('month');

        var daysInMonth = firstDay.daysInMonth();
        var dayOfWeek = firstDay.day();
        var daysBefore = dayOfWeek == 0 ? 6 : dayOfWeek - 1;

        var weeks = Math.ceil(
            (daysBefore + daysInMonth) / 7
        );

        var start = firstDay.clone().subtract(daysBefore, 'days');
        var days = [];
        var totalDays = weeks * 7;

        for(var i = 0; i < totalDays; i++)
        {
            days.push({
                date: start.format('DD/MM/YYYY'),
                day: start.date(),
                month: start.month(),
                year: start.year()
            });
            start.add(1, 'day');
        }

        return days;
    },
    visibleTicketsLimit(){
        var rows = this.daysGrid.length / 7;

        //Para 5 filas o menos
        if(rows <= 5) return 4;

        return 3; // Mas de 5
    }
},

methods: {
    AddMonth(value){
        var date = moment()
            .month(this.currentMonth)
            .year(this.currentYear)
            .date(1);

        if(value == -1 || value == 1) date.add(value, 'month');
        else if(value >= 2 && value <= 12) date.month(value - 1);

        this.currentMonth = date.month();
        this.currentYear = date.year();

        this.$emit('OnMonthChanged', {
            month: this.currentMonth + 1,
            year: this.currentYear
        });
    },
    TicketsForDate(date)
    {
        return this.ticketsByDate[date] || [];
    },
    HiddenTicketsCount(date)
    {
        var total = this.TicketsForDate(date).length;
        return Math.max(total - this.visibleTicketsLimit, 0);
    },
    TicketTime(ticket)
    {
        if(!ticket.custom_data || !ticket.custom_data.scheduled_at) return '';
        var date = moment.unix(ticket.custom_data.scheduled_at);
        if(!date.isValid()) return '';
        return date.format('HH:mm');
    },

    TicketCustomer(ticket)
    {
        if(ticket.customer && ticket.customer.name) return ticket.customer.name;
        return '#'+ticket.id_ticket;
    },

    VisibleTicketsForDate(date)
    {
        return this.TicketsForDate(date).slice(0, this.visibleTicketsLimit);
    },
    SelectYear(year)
    {
        this.currentYear = year;

        this.$emit('OnMonthChanged', {
            month: this.currentMonth + 1,
            year: this.currentYear
        });
    },
    ReturnFromList(date) {
        if(!date) return;
        let [, month, year] = date.split('/').map(Number);
        this.currentMonth = month - 1;
        this.currentYear = year;
        this.scheduledDateFilter = date;
    }
}

}
</script>
<style lang="scss">

.scheduled-calendar {
    width: 100%;
    height: 100%;
    display: flex;
    flex-direction: column;
    overflow: hidden;

    .calendar-title {
        font-size: 18px;
        font-weight: 600;
        text-transform: capitalize;
    }

    .calendar-week-header {
        flex-shrink: 0;
        display: grid;
        grid-template-columns: repeat(7, minmax(0, 1fr));
        height: 32px;
    }


    .week-day {
        display: flex;
        align-items: center;
        justify-content: center;
        min-width: 0;
        font-size: 11px;
        font-weight: 500;
        border-right: 1px solid var(--gray-2);
        border-bottom: 1px solid var(--gray-2);
    }

    .calendar-grid {
        flex: 1;
        min-height: 0;
        height: 100%;
        display: grid;
        grid-template-columns: repeat(7, minmax(0, 1fr));
        grid-auto-rows: minmax(0, 1fr);
        overflow: hidden;
    }

    .calendar-day {

        min-width: 0;
        min-height: 0;
        padding: 5px;
        overflow: hidden;
        background-color: white;
        border-right: 1px solid var(--gray-2);
        border-bottom: 1px solid var(--gray-2);

        &:not(.other-month):hover {
            // background-color: var(--gray-3);
        }

        &.other-month {
            opacity: 0.4;
        }

        &.today {
            outline: 2px solid var(--blue);
            z-index: 1;
        }
    }

    .day-header {
        display: flex;
        justify-content: space-between;
        align-items: center;
        height: 22px;
        margin-bottom: 2px;
    }

    .day-number {
        display: flex;
        align-items: center;
        justify-content: center;
        width: 22px;
        height: 22px;
        flex-shrink: 0;
        font-size: 11px;
        border-radius: 50%;
    }

    .today-number {
        background-color: var(--gray-cyan);
        color: var(--blue);
        font-weight: 600;
    }


    .day-counter {
        padding: 1px 6px;
        border-radius: 10px;
        background-color: var(--gray-pink);
        color: var(--pink);
        font-size: 10px;
        font-weight: 600;
    }

    .day-tickets {
        display: flex;
        flex-direction: column;
        gap: 2px;
    }

    .scheduled-ticket {
        display: flex;
        align-items: center;
        min-width: 0;
        height: 20px;
        padding: 2px 5px;
        flex-shrink: 0;
        border-radius: 3px;
        background-color: var(--gray-pink);
    }

    .ticket-time {
        flex-shrink: 0;
        margin-right: 4px;
        color: var(--pink);
        font-size: 9px;
    }

    .ticket-customer {
        min-width: 0;
        overflow: hidden;
        text-overflow: ellipsis;
        white-space: nowrap;
        font-size: 13px;
    }

    .more-tickets {
        height: 18px;
        padding: 1px 4px;
        flex-shrink: 0;
        text-align: center;
        color: var(--pink);
        font-size: 9px;
        font-weight: 600;
    }

}

.dark {

    .scheduled-calendar {

        .week-day {
            border-color: var(--dark-outline);
        }

        .calendar-grid {
            border-color: var(--dark-outline);
        }

        .calendar-day {
            background-color: var(--dark-bg-0);
            color: var(--dark-fc-1);
            border-color: var(--dark-outline);

            &.today {
                // background-color: var(--dark-bg-1);
                outline-color: var(--cyan);
            }
            &.other-month {
                background-color: var(--dark);
            }

            &:not(.other-month):hover {
                // background-color: var(--dark-bg);
            }

        }


        .today-number {
            background-color: var(--dark-outline);
            color: var(--cyan);
        }

        .scheduled-ticket {
            background-color: var(--dark-bg-3);
        }

        .ticket-time {
            // color: var(--cyan);
        }

        .more-tickets {
            // color: var(--cyan);
        }

        .day-counter {
            background-color: var(--dark-outline);
        }

    }

}

@media (max-width: 768px) {

    .scheduled-calendar {
        .day-counter {
            min-width: 18px;
            height: 18px;
            display: flex;
            align-items: center;
            justify-content: center;
            padding: 0 4px;
            border-radius: 9px;
            font-size: 10px;
            font-weight: 600;
        }

    }

}

</style>